export function dispatchEvent(eventName='') {
    window.dispatchEvent(new Event(eventName));
}

export function dispatchCustomEvent(eventName, fields) {
    window.dispatchEvent(new CustomEvent(eventName, fields));
}
